require("whatwg-fetch"); // Global

const Path = require("path");

const RootURL = require("./Config.js").RootApiUrl;
const authenticator = require("./authenticator.js");

const authenticationDispatchers =
    require("~/events/authentication/authenticationDispatchers.js");

const jsonHeaders = {
    "Accept": "application/json",
    "Content-Type": "application/json"
};

const server = {
    Get(url) {
        let fullUrl = toFullUrl(url);

        let promise = getPromiseForFetchWithToken((token) => {
            let config = {
                headers: getDefaultHeaders(token)
            };

            return fetch(fullUrl, config);
        });

        return promise;
    },
    Post(url, data) {
        let fullUrl = toFullUrl(url);

        let promise = getPromiseForFetchWithToken((token) => {
            let headers = Object.assign(
                getDefaultHeaders(token),
                jsonHeaders);

            let config = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data)
            };

            return fetch(fullUrl, config);
        });

        return promise;
    },
    Put(url, data) {
        let fullUrl = toFullUrl(url);

        let promise = getPromiseForFetchWithToken((token) => {
            let headers = Object.assign(
                getDefaultHeaders(token), 
                jsonHeaders);
            
            let config = {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(data)
            };

            return fetch(fullUrl, config);
        });

        return promise;
    },
    Delete(url) {
        let fullUrl = toFullUrl(url);

        let promise = getPromiseForFetchWithToken((token) => {
            let config = {
                method: "DELETE",
                headers: getDefaultHeaders(token)
            };

            return fetch(fullUrl, config);
        });

        return promise;
    }
};

// Tricky:
/**
 * @param {tokenConsumingFetch} - a function that accepts
 *  an OAuth token, and returns a whatwg-fetch promise.
 */
function getPromiseForFetchWithToken(tokenConsumingFetch) {
    function resolver(resolve, reject) {
        // Load the token, automatically prompting a login
        // if loading fails.
        authenticator.LoadToken(true).then((token) => {
            // Do stuff with the token, i.e. whatever was 
            // specified -- this should return a promise.
            tokenConsumingFetch(token)
                .then(checkForError)
                // Resolve the promise only if there's a
                // response at this point.  (If there's
                // not, there must have been an error,
                // so .catch will be called, below.)
                .then((response) => {
                    if (response) resolve(response);
                })
                .catch(reject);
        });
    }

    var promise = new Promise(resolver);

    return promise;
}

function getDefaultHeaders(token) {
    return {
        Authorization: "Bearer " + token
    };
}

function toFullUrl(path) {
    return Path.join(RootURL, path).replace(":/", "://");
}

function checkForError(response) {
    if (response.status >= 300) {
        if (response.status === 401 || response.status === 403) {
            raiseUnauthorized(response);
        }
        else {
            const error = new Error(response.statusText);
            error.response = response;

            throw error;
        }
    }
    else {
        return response;
    }
}

function raiseUnauthorized(response) {
    const actionType =
        response.status === 401
        ? "Unauthorized"
        : "Unauthenticated";

    const error = new Error(response.statusText);
    error.response = response;

    authenticationDispatchers.Errored(error);
}

module.exports = server;


// WEBPACK FOOTER //
// ./src/server.js